/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var SortDownIcon = createIcon({
  name: 'SortDownIcon',
  height: 512,
  width: 320,
  svgPath: 'M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default SortDownIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/sort-down-icon.js
// module id = 946
// module chunks = 0